import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { kv } from '../../lib/format';
import { card, cardPad } from '../../lib/ui';

export default function Match() {
  const { set, L } = useApp();
  const matchSteps = [
    { num: '1', label: L('PO Issued', 'ออก PO แล้ว') },
    { num: '2', label: L('Goods Receipt', 'ใบรับสินค้า') },
    { num: '3', label: L('Invoices Received', 'รับใบแจ้งหนี้แล้ว') },
    { num: '4', label: L('3-Way Match', 'การจับคู่ 3 ทาง') },
  ];
  const matchDocs = [
    { title: L('Purchase Order', 'ใบสั่งซื้อ (PO)'), border: '1px solid var(--color-border)', rows: [kv('PO', 'PO-2026-0041', 'var(--font-mono)'), kv(L('Value', 'มูลค่า'), '$4,620,000', 'var(--font-mono)'), kv(L('Supplier', 'ซัพพลายเออร์'), 'Apex Insurance Co.', 'var(--font-sans)')] },
    { title: L('Goods Receipt', 'ใบรับสินค้า'), border: '1px solid var(--color-border)', rows: [kv('GR', 'GR-2026-0031', 'var(--font-mono)'), kv(L('Received by', 'รับโดย'), 'Kris P.', 'var(--font-sans)'), kv(L('Date', 'วันที่'), '2026-07-01', 'var(--font-mono)')] },
    { title: L('Invoice', 'ใบแจ้งหนี้'), border: '2px solid var(--color-error)', rows: [kv(L('Invoice', 'ใบแจ้งหนี้'), 'INV-2026-0063', 'var(--font-mono)'), kv(L('Amount incl. VAT', 'จำนวนเงินรวมภาษีมูลค่าเพิ่ม'), '$4,975,500', 'var(--font-mono)'), kv(L('Variance', 'ส่วนต่าง'), '+$30,000', 'var(--font-mono)')] },
  ];
  const matchGr = [
    { item: 'Class 1 Comprehensive — 8 vehicles', unit: 'policy', ordered: '1', received: '1' },
  ];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 0, marginBottom: 18, ...cardPad('18px 20px') }}>
        {matchSteps.map((s) => (
          <div key={s.num} style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <div style={{ width: 28, height: 28, flex: 'none', borderRadius: 999, background: 'var(--color-blue)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{s.num}</div>
            <span style={{ fontSize: 13, fontWeight: 600, marginLeft: 10 }}>{s.label}</span>
            <div style={{ flex: 1, height: 2, background: 'var(--color-border)', margin: '0 12px' }} />
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', background: 'var(--color-error-bg)', border: '1px solid var(--color-error)', borderRadius: 'var(--radius-md)', marginBottom: 18, color: 'var(--color-error)' }}>
        <Icon name="alert-triangle" style={{ fontSize: 20 }} />
        <div style={{ fontSize: 14, color: 'var(--color-fg-1)' }}><b>{L('Match Failed', 'จับคู่ไม่สำเร็จ')}</b>{L(' — variance of $30,000. Invoiced amount exceeds the PO value. Payment is on hold pending resolution.', ' — ส่วนต่าง $30,000 ยอดที่ออกใบแจ้งหนี้เกินมูลค่า PO การชำระเงินถูกระงับจนกว่าจะแก้ไข')}</div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 16 }}>
        {matchDocs.map((d) => (
          <div key={d.title} style={{ background: 'var(--color-white)', border: d.border, borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-card)', padding: 18 }}>
            <div style={{ fontWeight: 700, marginBottom: 12 }}>{d.title}</div>
            {d.rows.map((r) => (
              <div key={r.k} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid var(--color-border)', fontSize: 13 }}>
                <span style={{ color: 'var(--color-fg-3)' }}>{r.k}</span>
                <span style={{ fontWeight: 600, fontFamily: r.font }}>{r.v}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div style={{ ...card, overflow: 'auto', marginBottom: 16 }}>
        <div style={{ padding: '12px 16px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Goods Receipt Line Items', 'รายการใบรับสินค้า')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)' }}>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Item', 'รายการ')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Unit', 'หน่วย')}</th>
              <th style={{ textAlign: 'right', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Ordered', 'สั่ง')}</th>
              <th style={{ textAlign: 'right', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Received', 'รับแล้ว')}</th>
            </tr>
          </thead>
          <tbody>
            {matchGr.map((g) => (
              <tr key={g.item}>
                <td style={{ padding: '11px 16px' }}>{g.item}</td>
                <td style={{ padding: '11px 16px', color: 'var(--color-fg-3)' }}>{g.unit}</td>
                <td style={{ padding: '11px 16px', textAlign: 'right', fontFamily: 'var(--font-mono)' }}>{g.ordered}</td>
                <td style={{ padding: '11px 16px', textAlign: 'right', fontFamily: 'var(--font-mono)' }}>{g.received}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button onClick={() => set({ invoiceDocOpen: true })} className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 20px', border: '1px solid var(--color-border-strong)', background: 'var(--color-white)', color: 'var(--color-fg-1)', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14 }}>
          <Icon name="file-text" />{L('View Invoice', 'ดูใบแจ้งหนี้')}
        </button>
        <button className="hv-danger" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 20px', background: 'var(--color-error)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14 }}>
          <Icon name="alert-triangle" />{L('Escalate to CCO', 'ส่งเรื่องถึง CCO')}
        </button>
      </div>
    </>
  );
}
